import React from 'react'
import css from './style.scss'
import {Link} from 'react-router-dom'

export default (props)=>(
  <div className={css.info}>
    <div>
      <h2>Why you ask to connect with Facebook?</h2>
      <p>
        Connecting <b>Stori</b> to your Facebook accounts permits us to access your Instagram Account.<br/>
        It's the only legal way to view your <b>Instagram Stories</b> without asking your Instagram password.<br/>
      </p>

      <h2>Do I need to be an Instagram Business Account to use Stori?</h2>
      <p>
        Though question:</p>
        <ul>
        <li><b>Yes</b> if you want to import and handle your Instagram Stories.</li>
        <li><b>No</b> if you need to collaborate on another account.</li>
        </ul>
        <p>
        Unfortunately Instagram and Facebook doesn't permit us to access the Stories if you aren't a Business Account.<br/>

      </p>

      <h2>I have other questions.</h2>
      <p>We're here to answer! Check out the <Link to="/faq">FAQ section</Link> with all the common questions.</p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/auth/auth_info.js